export enum TipoNivelEstudios
{
    EducacionBasica = "Educación Básica",
    EducacionMedia = "Educación Media",
    Tecnico = "Técnico",
    Profesional = "Profesional",
    PostGrado = "Post Grado",
}